/**
 * Maps a provider profit value to a symbol descriptor used to render the
 * profit indicator: { number, className }. Returns null when profit is null.
 */
export const getProfitSymbol = (profit) => {
	if (profit == null) return null
	if (profit <= -15) return { number: 3, className: '#8B0000' }
	if (profit <= 0) return { number: 2, className: '#8B0000' }
	if (profit <= 10) return { number: 4, className: '#d3b610' }
	if (profit <= 30) return { number: 0, className: '#23a823' }
	return { number: 1, className: '#23a823' }
}
